import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styles from './FlashMessage.scss';
import SuccessImage from '../../../assets/images/FlashMessages/checked.svg';
import ErrorImage from '../../../assets/images/FlashMessages/error.svg';

const FlashMessage = props => {
  const { t } = useTranslation('common');

  const isSuccess = props.type === 'success';

  return (
    <div className={styles['flash-message__container']}>
      <img
        className={styles['flash-message__icon']}
        alt={isSuccess ? t('flash_message.success_alt') : t('flash_message.error_alt')}
        src={isSuccess ? SuccessImage : ErrorImage}
      />
      <div className={styles['flash-message__message']}>{props.message}</div>
    </div>
  );
};

FlashMessage.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default FlashMessage;
